import {
    SPI,
    ActionType,
    BaseActionWidget,
    ValidateFormActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import customizeViewExport from './customizeViewGoodsExport.vue'
import { cloneDeep } from 'lodash-es';

@SPI.ClassFactory(
    BaseActionWidget.Token({
        viewType:ViewType.Table,
        actionType: ActionType.Client,
        name: '$$internal_ValidateForm',
        model: "deli.aries.trade.DeliSpecialApplyOrderDetail",
        widget: 'ClientAction',
    })
)
export class customizeViewGoodsExport extends ValidateFormActionWidget {
    initialize(props: any) {
        super.initialize(props);
        this.setComponent(customizeViewExport)
        return this;
    }

    @Widget.Reactive()
    get rows() {
        return cloneDeep(this.dataSource);
    }
    @Widget.Reactive()
    get rModel() {
        return this.model;
    }

}
